import { create } from 'zustand'

interface UIState {
  sidebarOpen: boolean
  setSidebarOpen: (v: boolean) => void
  toggleSidebar: () => void
}

// Defaults closed on mobile/tablet viewports so first paint doesn't show an
// off-canvas drawer already covering the screen.
const initialSidebarOpen = typeof window === 'undefined' ? true : window.innerWidth >= 1024

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: initialSidebarOpen,
  setSidebarOpen: (v) => set({ sidebarOpen: v }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
}))
